import React from 'react'
import { GetServerSideProps, NextPage } from 'next'
import { getSEOServersideProps, PagePropsWrapper } from 'lib/routing/nextPageUtils'
import { Partner } from 'services/ContentfulService/models/partner/partner'
import { getTreeIds } from 'services/ContentfulService/models/product'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { NamedPromises } from 'lib'
import { getPartners } from 'services/ContentfulService/models/partner/hooks'
import {
	FeaturedConstraint,
	NotHiddenConstraint,
	OrderByDisplayRankContraint,
	PartnerProductConstraint,
	TopicProductConstraint
} from 'services/ContentfulService/constraints'
import { referencesMultiple } from 'services/ContentfulService/utils'
import { getFaqsByProduct } from 'services/ContentfulService/hooks/faqs'
import { LoansContentPage, LoansExplorePageProps } from 'experiences/explore/loans/ContentPage/LoansContentPage'
import { Topic } from 'services/ContentfulService/models/topics'
import { getTopics } from 'services/ContentfulService/hooks/topics'
import { getProducts } from 'lib/cache/productTree'

const ExploreLoansPage: NextPage<PagePropsWrapper<LoansExplorePageProps>> = ({ metaTags, pageProps }) => (
	<StandardLayout metaTags={metaTags}>
		<LoansContentPage {...pageProps} />
	</StandardLayout>
)

export const getServerSideProps: GetServerSideProps = getSEOServersideProps<LoansExplorePageProps>(async function () {
	const products = await getProducts()
	const product = products.find(p => p.slug === 'loans')!
	const treeProductIds = getTreeIds(product)
	const partnersPromise = referencesMultiple<Partner>(treeProductIds, id =>
		getPartners({ constraints: [PartnerProductConstraint(id), OrderByDisplayRankContraint()], count: 6 })
	)
	const featuredPartnersPromise = referencesMultiple<Partner>(treeProductIds, id =>
		getPartners({ constraints: [PartnerProductConstraint(id), FeaturedConstraint()], count: 5 })
	)
	const topicsPromise = referencesMultiple<Topic>(treeProductIds, id =>
		getTopics({ constraints: [TopicProductConstraint(id), NotHiddenConstraint()], count: 4 })
	)

	return await NamedPromises({
		product: Promise.resolve(product),
		faqs: getFaqsByProduct(product),
		partners: partnersPromise,
		featuredPartners: featuredPartnersPromise,
		topics: topicsPromise
	})
})

export default ExploreLoansPage
